import { captureExperimentExposure } from './util/experimentExposure';

// For a tested surface with no client behaviour of its own: exposure only.
export default function experimentExposure({ experiment } = {}) {
    return {
        init() {
            captureExperimentExposure(experiment?.key, experiment?.variant);
        },
    };
}
